import type { MiddlewareFunction } from 'react-router';
import type { EvaluatorModel } from '~/evaluator/domain/evaluator';
import type { ValidatedToken } from '~/evaluator/service/token-exchange.service';
import { tokenContext } from '~/evaluator/view/evaluator-token';

export function discoveryOnly({ context }: MiddlewareArgs): void {
  requireModel(context.get(tokenContext), ['DISCOVERY', 'DDDRS']);
}

export function discoveryApiOnly({ context }: MiddlewareArgs): void {
  requireModel(context.get(tokenContext), ['DDDRS']);
}

export function exploreOnly({ context }: MiddlewareArgs): void {
  requireModel(context.get(tokenContext), ['EXPLORE']);
}

export function discoveryFullCircleOnly({ context }: MiddlewareArgs): void {
  requireModel(context.get(tokenContext), ['DFC']);
}

type MiddlewareArgs = Parameters<MiddlewareFunction>[0];

function requireModel(
  { model }: ValidatedToken,
  models: EvaluatorModel[],
): void {
  if (!models.includes(model))
    throw new Error(`Unexpected evaluator model: ${model}`);
}
